import React from "react";

import { Icons } from "../../data/Assets";

import { ITreeItem } from "../../interfaces/tree";
import { EtySchool } from "../../interfaces/entities";

import { getElipsisString, getFormattedString } from "../../helpers/utility";

import { SVGIcon } from "../wrappers/SVGIcon";

const TreeItem = (item: ITreeItem) => {
    const { type, level, name, method, onClickItem, children, selected, expanded, lastLevel, data } = item;

    return (
        <div className='immersion_admin__tree__item'>
            <button
                className={`btn_block immersion_admin__tree__item__btn immersion_admin__tree__item__btn__lvl_${level + 1} ${expanded ? 'immersion_admin__tree__item__btn__expanded' : ''} ${selected ? 'immersion_admin__tree__item__btn__selected' : ''}`}
                onClick={() => onClickItem(item)}
            >
                <SVGIcon src={level === lastLevel ? Icons.PointFill : Icons.TriangleFill} color='primary' />
                {(type === 'school' && level === 0) &&
                    <span className={`immersion_admin__tib__status_pill immersion_admin__tib__status_pill__${(data as EtySchool).status}`}>
                        {getFormattedString((data as EtySchool).status, 'title_case')}
                    </span>
                }
                <span>{getElipsisString(name, 35)}</span>
            </button>
            {children.length > 0 && expanded &&
                <div className="immersion_admin__tree__item__children">
                    {children.map((child, idx) =>
                        <TreeItem
                            type={type}
                            key={child.id}
                            id={child.id}
                            level={level + 1}
                            name={child.name}
                            method={child.method}
                            parentMethod={method}
                            onClickItem={onClickItem}
                            data={child.data}
                            selected={child.selected}
                            expanded={child.expanded}
                            lastLevel={lastLevel}
                        >
                            {child.children}
                        </TreeItem>
                    )}
                </div>
            }
        </div>
    );
};

export default TreeItem;